module.exports = __webpack_public_path__ + "static/week_grid_2_pages-fa9c541bcbcb91d9d23e093118ea0728.png";